import React, { useCallback } from 'react';
import useSWR from 'swr';

import byteSize from 'byte-size';

import ConfirmationDialog from '../../../common/ConfirmationDialog/ConfirmationDialog';
import ContactSupport from '../../../common/Labels/ContactSupportLink';
import Label from '../../../common/Labels/Label';

import { measureStorageSizeForOrchestrations } from '../../../../utils/api_functions/deleteOrchestration';

export const useOrchestrationStorageSize = (orchId) => {
  const {
    data,
    error,
    isLoading,
  } = useSWR(['orchestration-storage-size', [orchId]], measureStorageSizeForOrchestrations, {
    refreshInterval: 3000,
    loadingTimeout: 1000,
  });

  return {
    data,
    error,
    isLoading,
  }
}

export const OrchestrationRemovalModal = ({
  error = null,
  orchestration = {},
  onOrchestrationRemoved = () => {},
  showDialog = false,
  onDialogToggle = () => {},
}) => {
  const orchId = orchestration?.original?.id;
  const workspaceName = orchestration?.original?.workspace?.name;

  const { data } = useOrchestrationStorageSize(orchId);
  const storage = data?.bytes || 0;
  const storageData = byteSize(storage);
  const storageLabel = `${storageData.value} ${storageData.unit}`;
  const isLastEntry = storage > 0;

  const message = isLastEntry
    ? 'The selected workload, its associated tasks, and all its stored artifacts will be permanently deleted from Wallaroo. Are you sure?'
    : `The selected workload and associated tasks will no longer be available in the ${workspaceName} workspace. Are you sure?`

  const onConfirm = useCallback(() => {
    onOrchestrationRemoved(orchId);
  }, [orchId, onOrchestrationRemoved])

  return (
    <ConfirmationDialog
      title="Delete Workload"
      confirmButtonText="Delete"
      confirmButtonType="danger"
      showDialog={showDialog}
      onDialogToggle={onDialogToggle}
      modalAnimationKey="delete-orchestration-modal"
      onConfirm={onConfirm}
      error={error}
    >
      <div className="w-small-modal p-2 m-1 flex flex-col">
        <Label>
          { message }
        </Label>
        {
          isLastEntry && (
            <Label className="mt-2">
              Storage to be freed: { storageLabel }
            </Label>
          )
        }
        {
          error && (
            <div className="p-2">
              <Label color="error" size="sm">
                Error while deleting the workload. Please try again or <ContactSupport>contact support</ContactSupport> if the issue persists.
              </Label>
            </div>
          )
        }
      </div>
    </ConfirmationDialog>
  )
};

export default OrchestrationRemovalModal;
